/*
 * 催收机器人
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { ListCallingPlanReq, CallingPlanReq } from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
    Page: Page;
    id: string;
    // 计划名称
    planName: string;
    // 策略名
    strategy: string;
    // 开始时间 - 结束时间
    timeRange: string;
    sequence: number;
    company: string;
    itemids: string;// 工单类型
    usergroupids: string;// 角色ID
    userstaffids: string;// 员工ID
    status:string
    groupName:string;
    agentName:string;
    templateName:string;
    callingType:string;
    repeatTimes:string;
    maxLostRate:string;
    voicemailRedial:string;
    resultStrategies:string;
}
export function getListCallingPlanReq(arg: Options) {
    let request: any = new ListCallingPlanReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setPlanname(arg.planName)
    request.setStrategy(arg.strategy);
    request.setTimerange(arg.timeRange);
    request.setCallingtype(arg.callingType);
    return request;
}
//  机器人列表
export const getListCallingPlanRequest = new InnerRequest(
    ticketClient,
    ticketClient.listCallingPlan
);
export function addCallingPlanReq(arg: Options) {
    let request: any = new CallingPlanReq();
    request.setId(arg.id);
    request.setPlanname(arg.planName)
    request.setStrategy(arg.strategy);
    request.setTimerange(arg.timeRange);
    request.setSequence(0);
    request.setCompany(arg.company);
    request.setItemids(arg.itemids); //工单类型
    request.setUsergroupids(arg.usergroupids); //角色
    request.setUserids(arg.userstaffids); //员工
    request.setHours(arg.sequence)
    request.setStatus(Number(arg.status))
    request.setGroupname(arg.groupName);
    request.setAgentname(arg.agentName);
    request.setTemplatename(arg.templateName);
    request.setCallingtype(arg.callingType);
    request.setRepeattimes(arg.repeatTimes);
    request.setMaxlostrate(arg.maxLostRate);
    request.setVoicemailredial(arg.voicemailRedial);
    request.setResultstrategies(arg.resultStrategies);
    return request;
}
//  新增机器人
export const addCallingPlanRequest = new InnerRequest(
    ticketClient,
    ticketClient.createCallingPlan
);
export function editCallingPlanReq(arg: Options) {
    let request: any = new CallingPlanReq();
    request.setId(arg.id);
    request.setPlanname(arg.planName)
    request.setStrategy(arg.strategy);
    request.setTimerange(arg.timeRange);
    request.setSequence(0);
    request.setCompany(arg.company);
    request.setItemids(arg.itemids); //工单类型
    request.setUsergroupids(arg.usergroupids); //角色
    request.setUserids(arg.userstaffids); //员工
    request.setHours(arg.sequence)
    request.setStatus(Number(arg.status))
    request.setGroupname(arg.groupName);
    request.setAgentname(arg.agentName);
    request.setTemplatename(arg.templateName);
    request.setCallingtype(arg.callingType);
    request.setRepeattimes(arg.repeatTimes);
    request.setMaxlostrate(arg.maxLostRate);
    request.setVoicemailredial(arg.voicemailRedial);
    request.setResultstrategies(arg.resultStrategies);
    return request;
}
//  编辑机器人
export const editCallingPlanRequest = new InnerRequest(
    ticketClient,
    ticketClient.editCallingPlan
);
export function deleteCallingPlanReq(arg: Options) {
    let request: any = new CallingPlanReq();
    request.setId(arg.id);
    request.setPlanname(arg.planName)
    request.setStrategy(arg.strategy);
    request.setTimerange(arg.timeRange);
    return request;
}
//  删除机器人
export const deleteCallingPlanRequest = new InnerRequest(
    ticketClient,
    ticketClient.delCallingPlan
);
